<style>
  .top-label {
    position: absolute;
    top: -20px;
    left: 0px;
    font-size: 12px;
    color: var(--green-800);
  }
</style>

<div style="display: flex; gap: 5px; align-items: center;">
  <div style="width: 100%">
    <div
      #container
      style="
        position: relative;
        box-sizing: border-box;
        padding: 8px 10px 4px 10px;
        align-items: center;
        border: 1px solid var(--green-800);
        border-radius: 4px;
        background-color: #ffffff;
      "
    >
      <input
        type="text"
        (focus)="_handle_onFocus($event)"
        (blur)="_handle_onBlur($event)"
        (keydown)="_handle_onKeyDown($event)"
        (keyup)="_handle_onKeyUp($event)"
        [(ngModel)]="sQuery"
        style="
          border: 0px;
          outline: none;
          background-color: inherit;
          width: 100%;
          box-sizing: border-box !important;
        "
      />
      <select
        class="auto-fill floatSelect"
        style="
          position: absolute;
          left: 0px;
          top: 30px;
          z-index: 1000;
          min-width: 100%;
          width: auto !important;
          scrollbar-width: none;
        "
        [size]="options.length"
        (mousedown)="_handle_onChange($event)"
        (change)="_handle_onChange($event)"
        [(ngModel)]="boundValue"
        #ddl
        [hidden]="options.length == 0 || isSelected"
      >
        @for (item of options; track item) {
          <option [value]="item.id">{{ item.name }}</option>
        }
      </select>
      @if (helpText != '') {
        <div class="helpOverlay" (mouseover)="showHelp($event)">?</div>
      }
      @if (helpVisible && helpText != '') {
        <div
          id="{{ myId }}_h"
          (mouseout)="hideHelp($event)"
          (click)="$event.stopPropagation()"
          class="contextHelpBox"
        >
          {{ helpText }}
        </div>
      }
      <div class="top-label">{{ label }}</div>
      <label for="ddl" class="tb-validation-msg" [hidden]="isValid">{{
        validationMsg
      }}</label>
    </div>
  </div>
  <div>
    <app-icon [type]="'MinusRemove'" [color]="'var(--green-800)'" (click)="clear_click()" style="cursor: pointer;"></app-icon>

  </div>
</div>
